// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let AssessmentConfigView
export default AssessmentConfigView = (function () {
  AssessmentConfigView = class AssessmentConfigView extends (
    require("lib/static-shim").default(
      require("lib/uniform/views/form").default
    )
  ) {
    initialize() {
      this.onSaveError = this.onSaveError.bind(this)
    }

    static initClass() {
      this.prototype.template = require("./templates/assessment-config.html")
      this.prototype.className = "pw-uniform white-focus"

      this.prototype.events = {
        "click .save-assessment-config": "saveConfiguration"
      }
    }

    behaviors() {
      const behaviors = super.behaviors()
      return _.extend(behaviors, {
        SwitchState: {
          baseState: this.getBaseState,
          bind: false
        },
        Bind: {
          bindEvent: null,
          serializeBindData() {
            return {
              model: this.model,
              state: this.state,
              switchState: this.switchState
            }
          }
        }
      })
    }

    getBaseState() {
      let baseState
      return (baseState = this.model.isNew()
        ? "configure-open"
        : "configure-closed")
    }

    saveConfiguration(e) {
      e.preventDefault()
      return this.model.save({
        error: this.onSaveError
      })
    }

    onSaveError(resp) {
      return console.error("saved assessment error!", resp)
    }

    getConfigPresets() {
      const presets = []
      for (let op of Array.from(this.model.assessmentTypeOptions)) {
        op.selected = `${op.value}` === `${this.model.get("assessment_type")}`
        presets.push(op)
      }
      return presets
    }

    getModeDisplay() {
      const type =
        this.model.assessmentTypeOptions[this.model.get("assessment_type") - 1]
      const mode = {
        name: type.mode,
        description: type.description
      }
      return mode
    }

    serializeData() {
      const data = super.serializeData()
      data.assessmentTypeOptions = this.getConfigPresets()
      data.mode = this.getModeDisplay()
      return data
    }
  }
  AssessmentConfigView.initClass()
  return AssessmentConfigView
})()
